import { useSuspenseQuery } from '@apollo/client';
import { FC, Suspense, useMemo } from 'react';

import { generateHTMLArticleContent } from '@xing-com/crate-articles-article-editor';
import { GenericError } from '@xing-com/crate-career-hub-common';
import { ErrorBoundary } from '@xing-com/crate-core-error-boundary';

import { GetCareerHubTopicArticleDocument } from '../graphql/career-hub-topic-page-article-query.gql-types';
import { TopicArticleSkeleton } from '../skeletons';

import * as Styled from './topic-article.styles';

export type TopicArticleProps = {
  globalId: string;
};

export const TopicArticleInner: FC<TopicArticleProps> = ({ globalId }) => {
  const { data } = useSuspenseQuery(GetCareerHubTopicArticleDocument, {
    variables: { globalId },
  });

  const articleContent = data?.articleByGlobalId?.content ?? '';

  const htmlContent = useMemo(
    () => generateHTMLArticleContent(articleContent),
    [articleContent]
  );

  return (
    <Styled.EditorContent dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

export const TopicArticle: FC<TopicArticleProps> = ({ globalId }) => {
  return (
    <ErrorBoundary
      onError={() => <GenericError refetch={() => window.location.reload()} />}
    >
      <Suspense fallback={<TopicArticleSkeleton />}>
        <TopicArticleInner globalId={globalId} />
      </Suspense>
    </ErrorBoundary>
  );
};
